import Link from "@mui/material/Link";
import type { LinkProps } from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";
import { styled } from "@mui/material/styles";

type RowTitleLinkProps = Omit<LinkProps, "component" | "variant" | "href" | "onClick" | "ref"> &
  ({ onClick: () => void; to?: never } | { to: string; onClick?: never });

const TruncatedLink = styled(Link)({
  display: "block",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}) as typeof Link;

/** Semibold, truncated link for the primary identifier cell in a data row: a button that runs
 *  `onClick`, or a navigation link to `to`. */
export function RowTitleLink({ onClick, to, children, ...props }: RowTitleLinkProps) {
  return to !== undefined ? (
    <TruncatedLink
      component={RouterLink}
      to={to}
      variant="body2"
      fontWeight={600}
      underline="hover"
      {...props}
    >
      {children}
    </TruncatedLink>
  ) : (
    <TruncatedLink
      component="button"
      variant="body2"
      fontWeight={600}
      underline="hover"
      textAlign="left"
      onClick={onClick}
      {...props}
    >
      {children}
    </TruncatedLink>
  );
}
